import { render, staticRenderFns } from "./LahanUmumPlantingHole.vue?vue&type=template&id=064f6e22"
import script from "./LahanUmumPlantingHole.vue?vue&type=script&lang=js"
export * from "./LahanUmumPlantingHole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports